import CrudBase from '../../../CrudBase';
import axios from '../../../../axios-common';

class SupervisorApi extends CrudBase {

  search = (text) => axios.get(`${this.endpoint}/get-by?text=${text}`);

  defaultMethods = {
    search: this.search,
  }
};

const supervisor = new SupervisorApi('api/v1/supervisor');

export default supervisor.defaultMethods;
